import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Image } from 'components/core/Image';
import { PSPModuleWrapper } from 'components/psp/PSPModuleWrapper';
import { PSPMarkdownContent } from 'components/psp/PSPMarkdown';

import './PSPImage.scss';


export default function PSPImage({ content, imageSrc, isAligned }) {
	return (
		<PSPModuleWrapper className={classnames('psp-image-content', { 'aligned-left': isAligned })}>
			<Image
				src={imageSrc}
				alt="psp-image"
				className="psp-image"

			/>
			<div className="psp-image-text-container">
				<PSPMarkdownContent content={content} />
			</div>
		</PSPModuleWrapper>
	);
}

PSPImage.propTypes = {
	content: PropTypes.string.isRequired,
	imageSrc: PropTypes.string.isRequired,
	isAligned: PropTypes.bool
};
